import { Checkbox, Grid } from "@mantine/core";
import { useMemo } from "react";

import { getColValue } from "../../../pages/Reports/Report/Report.utils";
import {
  Flex,
  StyledTable,
  StyledTd,
  StyledTh,
  StyledTr,
} from "../../../styled";
import {
  formatDateTimeUTC,
  type INMEARow,
  type INMEASection,
  sortNMEARowsByTime,
} from "./NMEAAutomationModal.utils";

import styles from "./NMEAAoutomationModalPreview.module.scss";

interface Props {
  section: INMEASection;
  sectionIndex: number;
  selectedSections: number[][];
  setSelectedSections: (selectedSections: number[][]) => void;
  onlyOneAllowed: boolean;
}

const NMEAAoutomationModalPreviewLegacy = ({
  section,
  sectionIndex,
  selectedSections,
  setSelectedSections,
  onlyOneAllowed,
}: Props) => {
  const sortedRows = useMemo(
    () => sortNMEARowsByTime(section.rows),
    [section.rows],
  );

  const handleToggle = (prev: boolean, index: number) => {
    const updatedSections = [...selectedSections];
    const isSelected = !prev;

    if (!isSelected) {
      updatedSections[sectionIndex] = updatedSections[sectionIndex].filter(
        i => i !== index,
      );
    } else {
      if (!updatedSections[sectionIndex]) {
        updatedSections[sectionIndex] = [];
      }
      if (onlyOneAllowed) {
        updatedSections[sectionIndex] = [];
      }
      updatedSections[sectionIndex].push(index);
    }
    setSelectedSections(updatedSections);
  };

  return (
    <Grid columns={2} p={10}>
      {sortedRows.map((row, index) => {
        const isSelected = selectedSections[sectionIndex]?.includes(index);

        return (
          <Grid.Col
            span={1}
            onClick={() => handleToggle(isSelected, index)}
            className={styles.selectableCol}
            key={index}>
            <StyledTable>
              <StyledTr>
                <StyledTh colSpan={2}>
                  <Flex align="center" gap={16}>
                    <Checkbox
                      pl={8}
                      checked={isSelected}
                      onChange={() => handleToggle(isSelected, index)}
                    />
                    <Flex direction="column" justify="flex-start" gap={0}>
                      {row.dateTimeUTC ?? row.dateTimeLT ? (
                        <>
                          {row.dateTimeLT && <Flex>{row.dateTimeLT}</Flex>}
                          {row.dateTimeUTC && <Flex>{row.dateTimeUTC}</Flex>}
                        </>
                      ) : (
                        formatDateTimeUTC(row.dateTime)
                      )}
                    </Flex>
                  </Flex>
                </StyledTh>
              </StyledTr>

              <StyledTr>
                <StyledTh>Column</StyledTh>
                <StyledTh>Data</StyledTh>
              </StyledTr>

              {Object.values(row.cols ?? {}).map(
                (col, colIdx) =>
                  col.unit !== "24lock" && (
                    <StyledTr key={colIdx}>
                      <StyledTd>
                        {col.name?.replaceAll("<br>", " ") ?? col?.NMEA ?? ""}
                      </StyledTd>
                      <StyledTd
                        style={
                          col.unit === "large/text" || col.unit === "text"
                            ? {
                                maxWidth: "400px",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                              }
                            : undefined
                        }>
                        {getColValue(col)}
                      </StyledTd>
                    </StyledTr>
                  ),
              )}
            </StyledTable>
          </Grid.Col>
        );
      })}
    </Grid>
  );
};

export default NMEAAoutomationModalPreviewLegacy;

